const MUTATION_TOTE_CART_CHECKOUT = `
mutation WebToteCartCheckout($input: ToteCartCheckoutV2Input!) {
  ToteCartCheckoutV2(input: $input) {
    success
    errors {
      error_code
      message
    }
    payment {
      id
      state
      gateway
      authorization_details
    }
    order {
      id
      successful
    }
    tote {
      id
      first_locked_at
      can_free_purchase
    }
    tote_swap_questionnaire {
      improvement_question
      theme_question
      options {
        key
        value
      }
    }
  }
}
`

export { MUTATION_TOTE_CART_CHECKOUT }
